import React from 'react';
import {connect} from 'react-redux';

// import './styles.scss';
import tutorialVideo from './assets/4006868833093d06696ae39c73ba2ffb.mp4';
import strings from 'utils/strings';
import AudioPlayer from 'components/AudioPlayer';
import audioNo from 'assets/sounds/no/1 0 Orddiktat Intro.mp3';
import audioNn from 'assets/sounds/nn/1 0 Orddiktat Intro.mp3';
import audioNoNorming from '../../assets/sounds/adult/ordiktatSounds/no/orddiktat-intro.mp3';
import audioNnNorming from '../../assets/sounds/adult/ordiktatSounds/nn/orddiktat-intro.mp3';

const audioObj = {
	no: audioNo,
	nn: audioNn,
};
const normingLanguageObj = {
	no: audioNoNorming,
	nn: audioNnNorming,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);
		const isNorming = this.props.isNorming ? 1 : 0;
		this.audio =
			isNorming === 1
				? normingLanguageObj[strings.getLanguage()]
				: audioObj[strings.getLanguage()];
		// Compute intro at render-time to reflect current language
	}

	render() {
		const {onNextStep} = this.props;
		const isNorming = this.props.isNorming ? 1 : 0;

		const intro =
			isNorming === 1
				? strings.orddiktatNormingIntro
				: strings.orddiktatIntro;
		let videoRef;

		return (
			<div className="lit-intro">
				<p
					style={{
						marginBottom: 0,
					}}
				>
					<AudioPlayer
						autoplay
						inline
						onPause={() => {
							videoRef.play();
						}}
						onErrorPlay={() => {
							console.log('Something went wrong');
						}}
						src={this.audio}
					/>

					{intro}
				</p>
				<div className="text-center">
					<div className="lit-preview">
						<p className="lit-preview__label">
							{strings.testLooksLikeThis}
						</p>
						<video
							className="lit-preview__video"
							loop
							ref={(ref) => {
								videoRef = ref;
							}}
							src={tutorialVideo}
						/>
					</div>
				</div>
				<div>
					<p className="showme">{strings.clickonplaybutton}</p>
				</div>
				<button
					className="lit-btn bg-primary"
					onClick={() => onNextStep()}
				>
					{strings.start}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
